import { Component, Input, ViewEncapsulation, Output, EventEmitter } from '@angular/core';

import { MenuItem, MenuItemExtended } from '../../../base/models/menu-items';
import { UserContext } from '../../../auth/models/auth';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class NavbarComponent {
  @Input() menuItems: MenuItem[]
  @Input() user: UserContext
  @Input() salesRep: boolean
  @Input() languages: string[]
  @Input() topMenuStyle: string

  @Output() onToggleNavBar = new EventEmitter<boolean>()
  @Output() onToggleMobileUserOptions = new EventEmitter<boolean>()
  @Output() onSelectCustomer = new EventEmitter()
  @Output() onItemClick = new EventEmitter<void>()

  constructor() { }

  toggleNavBar() {
    this.onToggleNavBar.emit()
  }

  toggleMobileUserOptions() {
    this.onToggleMobileUserOptions.emit();
  }

  selectCustomer() {
    this.onSelectCustomer.emit()
  }

  itemClick(): void {
    this.onItemClick.emit()
  }
}
